module.exports = __webpack_public_path__ + "media/images/page/problem_illust-982eda0065088e51e76afaecd307d7b4.png";